/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import LockResetIcon from '@mui/icons-material/LockReset';
import { Link } from '@mui/material';

import { BasicRoutes } from '../../constants/basicRoutes';
import { Namespaces } from '../../i18n';
import { useLoginActionsStyles } from './useLoginActionsStyles';

export const ForgotPasswordLink = memo(({ email }: { email?: string }) => {
  const navigate = useNavigate();
  const { t } = useTranslation(Namespaces.Login);
  const classes = useLoginActionsStyles();

  const handleForgotPassword = () => {
    const forgotUrl = `${BasicRoutes.FORGOT_PASSWORD}${email ? `?email=${encodeURIComponent(email)}` : ''}`;
    void navigate(forgotUrl);
  };

  return (
    <Link component="button" onClick={handleForgotPassword} className={classes.ssoLink}>
      <LockResetIcon sx={{ fontSize: '18px' }} />
      {t('page.forgot_password.title')}
    </Link>
  );
});
